/* resizeObserverFix — neutralises the benign
 *   "ResizeObserver loop completed with undelivered notifications"
 * browser warning. It is harmless, but CRA's dev error overlay treats it as a
 * fatal uncaught error and covers the whole app with a red box (which makes the
 * configurator look broken). The configurator's Three.js renderer + drei canvases
 * fire ResizeObserver frequently, so we:
 *   1) deferring each ResizeObserver callback to the next animation frame, which
 *      breaks the synchronous resize→layout→resize loop that triggers the warning;
 *   2) belt-and-suspenders: swallow the specific error before the dev overlay sees it.
 *
 * Imported FIRST in index.js so the patched global is in place before React, drei,
 * or the engine ever construct a ResizeObserver.
 */
(function patchResizeObserver() {
  if (typeof window === "undefined") return;

  const Native = window.ResizeObserver;
  if (Native && !Native.__lhcPatched) {
    const Patched = class extends Native {
      constructor(callback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => callback(entries, observer));
        });
      }
    };
    Patched.__lhcPatched = true;
    window.ResizeObserver = Patched;
  }

  const isRoLoop = (msg) =>
    typeof msg === "string" && msg.indexOf("ResizeObserver loop") !== -1;

  // Capture-phase listener runs before the dev-server overlay's handler and stops it.
  window.addEventListener(
    "error",
    (e) => {
      if (isRoLoop(e && e.message)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );

  const prevOnError = window.onerror;
  window.onerror = function (message, ...rest) {
    if (isRoLoop(message)) return true; // handled — don't bubble to the overlay
    return prevOnError ? prevOnError.apply(this, [message, ...rest]) : false;
  };
})();

export {};
